import { RouteType } from "types/RouteType";

const auditLogRoute: RouteType = {
  name: "AuditLog",
  path: "/admin/audit-log",
  layout: "/admin",
  viewportCard: {
    header: {
      enableBackButton: true,
      title: "Audit Log",
      // false: this page loads from its Body, not an onEnter, so the plate's
      // refresh (which re-runs onEnter) would do nothing. The header renders
      // the working Refresh button.
      enableRefreshButton: false,
      color: "primary",
      component: () => import("./AuditLog.Header"),
    },
    body: {
      component: () => import("./AuditLog.Body"),
      grayBackground: false,
    },
  },
  group: "Admin",
  searchAliases: ["activity", "history"],
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  enableAutoFind: false,
};

export default auditLogRoute;
